import React from "react";
import { useNavigate } from "react-router-dom";
import "./DashboardConfiguracion.css";

const DashboardConfiguracion = () => {
  const navigate = useNavigate();

 const configuraciones = [
  { id: 1, titulo: "Gestión de Perfil", descripcion: "Configura tus datos profesionales y la información que aparecerá en tus documentos.", boton: "Configurar", ruta: "/dashboard/configuracion/perfil" },
  { id: 2, titulo: "Seguridad de la Cuenta", descripcion: "Gestiona la contraseña de tu cuenta.", boton: "Configurar", ruta: "/dashboard/configuracion/seguridad" },
  { id: 3,  titulo: "Métodos de Pago", descripcion: "Administra tu plan, método de pago y estado de suscripción.", boton: "Configurar", ruta: "/dashboard/configuracion/pago" },
  { id: 4, titulo: "Personalizar expediente clínico", descripcion: "Personaliza los campos, preguntas y secciones de tu historia clínica y consultas, y configura cómo capturar la información de tus pacientes.", boton: "Configurar", ruta: "/dashboard/configuracion/cuestionario" },
  { id: 5,  titulo: "Agenda y recordatorios", descripcion: "Configura tu horario de atención, confirmaciones y recordatorios por WhatsApp.", boton: "Configurar", ruta: "/dashboard/citas", abrirConfigAgenda: true },
  { id: 6, titulo: "Receta Electrónica", descripcion: "Personaliza formato, firma, logo y datos visibles en tus recetas.", boton: "Configurar", ruta: "/dashboard/configuracion/receta" },
  { id: 7, titulo: "Auditoría de Actividad", descripcion: "Revisa cambios y acciones realizadas dentro de tu cuenta.", boton: "Ver", ruta: "/dashboard/configuracion/auditoria" },
];

  const handleNavigate = (config) => {
  if (config.abrirConfigAgenda) {
    navigate(config.ruta, { state: { abrirConfigAgenda: true } });
    return;
  }

  navigate(config.ruta);
};

  return (
    <div className="configuracion-layout">
      <h2>Dashboard de Configuración</h2>
      <div className="configuracion-tarjetas">
     {configuraciones.map((config) => (
  <div
    key={config.id}
    className="tarjeta-configuracion"
    onClick={() => handleNavigate(config)}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        handleNavigate(config);
      }
    }}
  >
  

    <div className="tarjeta-configuracion-body">
      <h3>{config.titulo}</h3>
      <p>{config.descripcion}</p>
    </div>

    <button
      onClick={(e) => {
        e.stopPropagation();
        handleNavigate(config);
      }}
    >
      {config.boton}
    </button>
  </div>
))}
      </div>
    </div>
  );
};

export default DashboardConfiguracion;
